export default "__VITE_ASSET__Ch2RING6__"